export const P_TASKQUEUE_CALLBACKApi = 1;
export var MembershipsExceptionCodesApi;
(function (MembershipsExceptionCodesApi) {
    MembershipsExceptionCodesApi["TRIAL_INELIGIBLE"] = "trial_ineligible";
    MembershipsExceptionCodesApi["PAYMENT_FAILURE"] = "payment_failure";
    MembershipsExceptionCodesApi["PACKAGE_DISABLED"] = "package_disabled";
    MembershipsExceptionCodesApi["PRICE_DISABLED"] = "price_disabled";
    MembershipsExceptionCodesApi["TRIAL_NOT_FOUND"] = "trial_not_found";
    MembershipsExceptionCodesApi["PRICE_NOT_FOUND"] = "price_not_found";
    MembershipsExceptionCodesApi["PACKAGE_NOT_FOUND"] = "package_not_found";
    MembershipsExceptionCodesApi["SUBSCRIPTION_NOT_FOUND"] = "subscription_not_found";
    MembershipsExceptionCodesApi["INVALID_PACKAGE_DURATION"] = "invalid_package_duration";
    MembershipsExceptionCodesApi["INVALID_SUBSCRIPTION_QUANTITY"] = "invalid_subscription_quantity";
    MembershipsExceptionCodesApi["MAIL_EXCEPTION"] = "mail_exception";
    MembershipsExceptionCodesApi["RENEW_PERIOD_EXPIRED"] = "renew_period_expired";
    MembershipsExceptionCodesApi["REFUND_FAILURE"] = "refund_failure";
    MembershipsExceptionCodesApi["COUPON_REUSE"] = "coupon_reuse";
    MembershipsExceptionCodesApi["COUPON_UNAVAILABLE"] = "coupon_unavailable";
    MembershipsExceptionCodesApi["REQUEST_ALREADY_PROCESSED"] = "request_already_processed";
    MembershipsExceptionCodesApi["PERIOD_NOT_FOUND"] = "period_not_found";
    MembershipsExceptionCodesApi["RENEWAL_ALREADY_ACTIVE"] = "renewal_already_active";
    MembershipsExceptionCodesApi["RENEWAL_NOT_FOUND"] = "renewal_not_found";
    MembershipsExceptionCodesApi["RENEWAL_ALREADY_INACTIVE"] = "renewal_already_inactive";
    MembershipsExceptionCodesApi["DAO_EXCEPTION"] = "dao_exception";
    MembershipsExceptionCodesApi["DB_EXCEPTION"] = "db_exception";
    MembershipsExceptionCodesApi["GAF_EXCEPTION"] = "gaf_exception";
    MembershipsExceptionCodesApi["INVALID_REQUEST"] = "invalid_request";
    MembershipsExceptionCodesApi["NOT_IMPLEMENTED"] = "not_implemented";
    MembershipsExceptionCodesApi["UNKNOWN_ERROR"] = "unknown_error";
})(MembershipsExceptionCodesApi || (MembershipsExceptionCodesApi = {}));
export var SubscriptionActionApi;
(function (SubscriptionActionApi) {
    SubscriptionActionApi["SUBSCRIBE"] = "subscribe";
    SubscriptionActionApi["UNSUBSCRIBE"] = "unsubscribe";
    SubscriptionActionApi["RENEW"] = "renew";
    SubscriptionActionApi["CANCEL"] = "cancel";
})(SubscriptionActionApi || (SubscriptionActionApi = {}));
export var AdminActionApi;
(function (AdminActionApi) {
    AdminActionApi["SUBSCRIBE"] = "subscribe";
    AdminActionApi["SUBSCRIBE_CUSTOM_PAYMENT"] = "subscribe_custom_payment";
    AdminActionApi["UNSUBSCRIBE_FULL_REFUND"] = "unsubscribe_full_refund";
    AdminActionApi["UNSUBSCRIBE_PARTIAL_REFUND"] = "unsubscribe_partial_refund";
    AdminActionApi["UNSUBSCRIBE_NO_REFUND"] = "unsubscribe_no_refund";
    AdminActionApi["CONTRACT_RENEWAL_CANCEL"] = "contract_renewal_cancel";
})(AdminActionApi || (AdminActionApi = {}));
export var SubscriptionStatusApi;
(function (SubscriptionStatusApi) {
    SubscriptionStatusApi["NONE"] = "none";
    SubscriptionStatusApi["PENDING"] = "pending";
    SubscriptionStatusApi["ACTIVE"] = "active";
    SubscriptionStatusApi["EXPIRED"] = "expired";
    SubscriptionStatusApi["CANCELLED"] = "cancelled";
})(SubscriptionStatusApi || (SubscriptionStatusApi = {}));
export var DowngradeStatusApi;
(function (DowngradeStatusApi) {
    DowngradeStatusApi["PENDING"] = "pending";
    DowngradeStatusApi["CANCELLED"] = "cancelled";
    DowngradeStatusApi["DONE"] = "done";
})(DowngradeStatusApi || (DowngradeStatusApi = {}));
export var RefundTypeApi;
(function (RefundTypeApi) {
    RefundTypeApi["NONE"] = "none";
    RefundTypeApi["UNUSED_ONLY"] = "unused_only";
    RefundTypeApi["FULL"] = "full";
})(RefundTypeApi || (RefundTypeApi = {}));
export var BenefitDuplicateRuleApi;
(function (BenefitDuplicateRuleApi) {
    BenefitDuplicateRuleApi["NONE"] = "none";
    BenefitDuplicateRuleApi["SUM"] = "sum";
    BenefitDuplicateRuleApi["MIN"] = "min";
    BenefitDuplicateRuleApi["MAX"] = "max";
    BenefitDuplicateRuleApi["EXISTS"] = "exists";
})(BenefitDuplicateRuleApi || (BenefitDuplicateRuleApi = {}));
export var SubscriptionTypeApi;
(function (SubscriptionTypeApi) {
    SubscriptionTypeApi["SUBSCRIBE"] = "subscribe";
    SubscriptionTypeApi["UPGRADE"] = "upgrade";
    SubscriptionTypeApi["DOWNGRADE"] = "downgrade";
    SubscriptionTypeApi["SWITCH_DURATION"] = "switch_duration";
    SubscriptionTypeApi["EXTEND"] = "extend";
})(SubscriptionTypeApi || (SubscriptionTypeApi = {}));
